<template>
  <vx-card
    title="Product/Features"
    class="mt-base"
  >
    <list-thumb-view :listing-id="listingId" />
  </vx-card>
</template>

<script>
import ListThumbView from '@/views/admin/listing-features/ListThumbView'

export default {
  props: {
    listingId: {
      type: String,
      required: true
    }
  },
  components: { ListThumbView }
}
</script>
